<script lang="ts">
  /**
   * TOP HEADER BAR
   * - Shows current page title (breadcrumb)
   * - User avatar/name dropdown with Logout action
   */
  import { router } from 'svelte-spa-router';
  import { authState } from '../features/auth/auth.state.svelte';
  import { getRouteMeta } from '../router/routes';

  interface Props {
    sidebarCollapsed?: boolean;
  }
  let { sidebarCollapsed = false }: Props = $props();

  let showDropdown = $state(false);

  const pageTitle = $derived(getRouteMeta(router.location).title);
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<header
  class="fixed top-0 right-0 h-16 bg-surface-800/80 backdrop-blur-md border-b border-surface-700
         flex items-center justify-between px-6 z-30 transition-all duration-300"
  style="left: {sidebarCollapsed ? '4rem' : '16rem'}"
>
  <!-- Breadcrumb / Page Title -->
  <div>
    <h1 class="text-lg font-semibold text-surface-100">{pageTitle}</h1>
  </div>

  <!-- User Dropdown -->
  <div class="relative">
    <button
      onclick={() => showDropdown = !showDropdown}
      class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-surface-700
             transition-colors cursor-pointer"
    >
      <!-- Avatar circle with first initial -->
      <div class="w-8 h-8 rounded-full bg-brand-600 flex items-center justify-center text-sm font-bold text-white">
        {authState.user?.fullName?.charAt(0) || '?'}
      </div>
      <div class="text-left hidden sm:block">
        <p class="text-sm font-medium text-surface-200">{authState.user?.fullName || 'User'}</p>
        <p class="text-xs text-surface-500">{authState.user?.role || 'unknown'}</p>
      </div>
      <span class="text-surface-500 text-xs">{showDropdown ? '▲' : '▼'}</span>
    </button>

    <!-- Dropdown Menu -->
    {#if showDropdown}
      <!-- Invisible backdrop to close dropdown on outside click -->
      <div class="fixed inset-0 z-40" role="presentation" onclick={() => showDropdown = false}></div>

      <div class="absolute right-0 mt-2 w-48 bg-surface-700 border border-surface-600 rounded-xl shadow-xl z-50 py-1 overflow-hidden">
        <div class="px-4 py-2 border-b border-surface-600">
          <p class="text-sm text-surface-200">{authState.user?.email}</p>
        </div>
        <button
          onclick={() => { showDropdown = false; authState.logout(); }}
          class="w-full text-left px-4 py-2.5 text-sm text-red-400 hover:bg-surface-600 transition-colors cursor-pointer"
        >
          🚪 Logout
        </button>
      </div>
    {/if}
  </div>
</header>
